import ImportExportIcon from '@mui/icons-material/ImportExport';
import TRCSortModal from '../sortModal';

const TopSectionWithoutFilter = ({ category, showSort = false, handleFilterChange, sortBy }) => {
	return (
		<>
			<div
				className={`c-tab_cata-text w-full d-lg-flex ${showSort ? 'justify-content-between' : 'justify-content-end'} d-none`}
			>
				{showSort && (
					<div className="c-filter_btn-one d-none d-lg-block" style={{ width: 'fit-content', marginLeft: '1.875rem' }}>
						<ImportExportIcon size={24} />
						<span>Sort by</span>
						<select className="filterby" value={sortBy}>
							<option value="latest">Newest</option>
							<option value="oldest">Oldest</option>
							<option value="title_asc">Title (A - Z)</option>
							<option value="title_desc">Title (Z - A)</option>
							<option value="long_duration">Longest</option>
							<option value="short_duration">Shortest</option>
						</select>
					</div>
				)}
				<h4>{category}</h4>
			</div>

			<div className={`d-flex px-1 ${showSort ? 'justify-content-between align-items-center' : 'justify-content-end'}`}>
				<h4 className="d-lg-none w-100 text-white text-left fw-bold" style={{ fontFamily: 'Good Times' }}>
					{category}
				</h4>
				{showSort && <TRCSortModal sortBy={sortBy} handleFilterChange={handleFilterChange} />}
			</div>
		</>
	);
};

export default TopSectionWithoutFilter;
